import { useCallback } from 'react';
import { useVocabulary } from '@/modules/core/hooks/useVocabulary';
import { useCreateVocabularyTerm } from './useVocabularyTerms';
import { collectNewVocabularyTerms } from '@/modules/core/utils/vocabulary';

/**
 * E5c — returns an async fn that persists any genuinely-new evolving-field
 * values on a form (`fuel_type`, `engine_type`) as provisional (needs_review)
 * catalog terms. Best-effort: a failed create (e.g. a duplicate the catalog
 * already has) is swallowed so it never blocks the boat save.
 */
export function useCreatePendingVocabularyTerms() {
  const { index } = useVocabulary();
  const { mutateAsync } = useCreateVocabularyTerm();

  return useCallback(
    async (values: Record<string, unknown>): Promise<void> => {
      const terms = collectNewVocabularyTerms(index, values);
      await Promise.all(
        terms.map((t) =>
          mutateAsync({ ...t, provisional: true }).catch((e) => {
            console.error('E5c: provisional vocabulary term create failed', t, e);
          }),
        ),
      );
    },
    [index, mutateAsync],
  );
}
